export var PhoneType;
(function (PhoneType) {
    // Home / Work
    PhoneType["Home"] = "home";
    PhoneType["Work"] = "work";
    // Other / Custom
    PhoneType["Other"] = "other";
    PhoneType["Custom"] = "custom";
    // Phone specific
    PhoneType["Mobile"] = "mobile";
    PhoneType["FaxWork"] = "fax_work";
    PhoneType["FaxHome"] = "fax_home";
    PhoneType["Pager"] = "pager";
    PhoneType["Callback"] = "callback";
    PhoneType["Car"] = "car";
    PhoneType["CompanyMain"] = "company_main";
    PhoneType["Isdn"] = "isdn";
    PhoneType["Main"] = "main";
    PhoneType["OtherFax"] = "other_fax";
    PhoneType["Radio"] = "radio";
    PhoneType["Telex"] = "telex";
    PhoneType["TtyTdd"] = "tty_tdd";
    PhoneType["WorkMobile"] = "work_mobile";
    PhoneType["WorkPager"] = "work_pager";
    PhoneType["Assistant"] = "assistant";
    PhoneType["Mms"] = "mms";
})(PhoneType || (PhoneType = {}));
export var EmailType;
(function (EmailType) {
    // Home / Work
    EmailType["Home"] = "home";
    EmailType["Work"] = "work";
    // Other / Custom
    EmailType["Other"] = "other";
    EmailType["Custom"] = "custom";
    // Email specific
    EmailType["Mobile"] = "mobile";
})(EmailType || (EmailType = {}));
export var PostalAddressType;
(function (PostalAddressType) {
    // Home / Work
    PostalAddressType["Home"] = "home";
    PostalAddressType["Work"] = "work";
    // Other / Custom
    PostalAddressType["Other"] = "other";
    PostalAddressType["Custom"] = "custom";
})(PostalAddressType || (PostalAddressType = {}));
//# sourceMappingURL=definitions.js.map